import { render, staticRenderFns } from "./musicIndex.vue?vue&type=template&id=ad2f8e4a&scoped=true&"
import script from "./musicIndex.vue?vue&type=script&lang=js&"
export * from "./musicIndex.vue?vue&type=script&lang=js&"
import style0 from "./musicIndex.vue?vue&type=style&index=0&id=ad2f8e4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f8e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2f8e4a')) {
      api.createRecord('ad2f8e4a', component.options)
    } else {
      api.reload('ad2f8e4a', component.options)
    }
    module.hot.accept("./musicIndex.vue?vue&type=template&id=ad2f8e4a&scoped=true&", function () {
      api.rerender('ad2f8e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/music/musicIndex.vue"
export default component.exports